import request from "@/axios.js";

export default class Order {
	/**
	 * Order class
	 * @param {object} order - Object containing all information about a order
	 * @property {string} brief_text - a brief.
	 * @property {number} budget - a budget.
	 * @property {number} status - a status.
	 * @property {number} billable - is billable?
	 * @property {number} contract_id - a contract_id.
	 * @property {number} product_id - an product_id.
	 * @property {number} account_manager_id - an account_manager_id.
	 */
	constructor(order) {
		this.id = order.id || null;
		this.brief_text = order.brief_text || null;
		this.budget = order.budget || 0;
		this.status = order.status || 1;
		this.billable = order.billable || 0;
		this.billable_price = order.billable_price || 0;
		this.contract_id = order.contract_id || null;
		this.product_id = order.product_id || null;
		this.account_manager_id = order.account_manager_id || null;
		this.period = order.period || null;
		this.language = order.language || null;
		this.num_words = order.num_words || null;
		this.difficulty = order.difficulty || null;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} order object
	 */
	static getFormFields(){
		return {
			id: null,
			brief_text: null,
			budget: null,
			status: 1,
			billable: 0,
			billable_price: 0,
			contract_id: null,
			product_id: null,
			account_manager_id: null,
			period: null,
			language: null,
			num_words: null,
			difficulty: null
		};
	}

	/**
	 * Get orders
	 * @returns 
	 */
	static getAll() {
		return new Promise((resolve, reject) => {
			request.get("/orders/all" + contract_id)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
		});
	}
	/**
	 * Get orders by contract_id
	 * @param {Nunber} contract_id 
	 * @returns 
	 */
	static getByContractId(contract_id) {
		return new Promise((resolve, reject) => {
			request.get("/orders/get/contract/" + contract_id)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
		});
	}
}
